export default __webpack_public_path__ + "static/4-select-project-180a3c55e3fb47feb55d663215b16348.png";